import $ from 'jquery';

class CustomParallax {
  constructor(obj) {
    const { element, elementNodes, callback, scrollCallback } = obj;

    if (!element) return false;
    
    this.el = $(element);

    
    this.offsetTop = this.el.offset().top;
    this.scroll = this._getTop(window);
    this.h = 0;
    this.elementsHeights = [];
    this.elementsThresholds = [];

    this.texts = elementNodes || this.el.find(".s-custom-parallax__item");
    this.timeout = 0;
    this.callback = callback;
    this.scrollCallback = scrollCallback;
    this._init();
  }

  _init() {
    this.texts.addClass("active");
    let finalH = 0;
    let speed = 2;

    this.texts.each((index, el) => {
      this.elementsHeights.push($(el).outerHeight() / speed);
      const prev = this.elementsThresholds[index - 1] || 0;
      this.elementsThresholds.push($(el).outerHeight() / speed + prev);
      finalH += $(el).outerHeight();
    });
    
    this.el.css("height", finalH );
    this.texts.removeClass("active");

    this.h = this.el.outerHeight();

    this._checkActive();
    this._createBullets()

    $(window).on("scroll", (e) => {
      this.scroll = this._getTop(e.target);
      this._checkActive();

      
    });
  }

  _getTop(target) {
    const top = $(target).scrollTop() - this.offsetTop;

    if (typeof this.scrollCallback === 'function') this.scrollCallback(top);

    return top
  }

  _checkActive() {
    let activeText = 0;
    this.texts.each((index, el) => {
      if (this.scroll < 0) {
        activeText = 0;
        return false;
      }

      if (this.elementsHeights[index - 1]) {
        if (this.scroll < this.elementsThresholds[index] && this.scroll >= this.elementsThresholds[index - 1]) {
          activeText = index;
        }
      } else {
        if (this.scroll >= this.elementsHeights[index]) {
          activeText = index;
        }
      }
    });

    activeText = activeText > this.texts.length - 1 ? this.texts.length - 1 : activeText;

    if (this.texts.eq(activeText).hasClass("active")) return;

  
    this._setActive(activeText);
    this._setActiveBullet(activeText)
  }

  _setActive(index) {
    this.texts.removeClass("active").removeClass("fade");
    this.texts.eq(index).addClass("active");

    $('video').trigger('play');

    console.log(this.texts.eq(index).find('video'))

  

    $(this.el).trigger("parallax:active", index);

    if (typeof this.callback === "function") this.callback(index);

    clearTimeout(this.setTimeout);
    this.timeout = setTimeout(() => {
      this.texts.eq(index).addClass("fade");
    }, 1);
  }

  _createBullets(){
    const items =  this.texts.length
    var list = this.el.find(".s-custom-parallax__bullets").append('<ul></ul>').find('ul');
    for (var i = 0; i < items; i++)
        list.append('<li></li>');
  }

  _setActiveBullet(index){
    setTimeout(() => {
      // console.log('li',this.el.find(".s-custom-parallax__bullets li"))


    this.el.find(".s-custom-parallax__bullets ul").each(function(i,elem){    
      $(elem).find('li').each(function(i,li){
        $(li).removeClass("active")
      })
     // $(elem).removeClass("active")
    })

    this.el.find(".s-custom-parallax__bullets ul").each(function(i,elem){    
      $(elem).find('li').eq(index).each(function(i, elem){
        // console.log('$this', $(this))
        $(elem).addClass("active");
      })
     
    })
    
    
    
    // .eq(index).each(function(i, elem){
    //   console.log('$this', $(this))
    //   $(elem).addClass("active");
    // })

 
    })
  }


}export default CustomParallax;
